import React from "react";
import "./CustomDashboard.scss";
import { Button } from "antd";
import TopicsList from "../../components/CustomDashboardComponents/TopicsList/TopicsList";
import { useNavigate } from "react-router-dom";

const CustomDashboard = () => {
  const navigate = useNavigate();
  const handleAddTopic = () => {
    navigate("/manage-topics/add");
  }
  return (
    <div className="custom-dashboard">
      <div className="custom-dashboard_container">
        <div className="custom-dashboard_header">
          <div className="custom-dashboard_header_left">
            <h2>Manage Topics</h2>
          </div>
          <div className="custom-dashboard_header_right">
            <Button type="primary" onClick={handleAddTopic}>Add Topic</Button>
          </div>
        </div>
        <div className="custom-dashboard_section">
          <TopicsList />
        </div>
      </div>
    </div>
  );
};

export default CustomDashboard;
